import api from '@pray/shared/utils/api';

import type { RecurringCampaignDetail } from './types';

// POST …/campaigns/recurring/:id/instances/:instanceId/retry — re-fire a failed
// occurrence. The server rewinds the recurring cursor so the cron picks the
// occurrence up again on its next poll; the request itself spawns nothing.
// Returns the refreshed detail DTO (the rewound cursor rides `last_processed_at`).
export async function retryRecurringCampaignInstance({
  artistId,
  recurringCampaignId,
  instanceId,
}: {
  artistId: string;
  recurringCampaignId: string;
  instanceId: string;
}): Promise<{ object: RecurringCampaignDetail }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!recurringCampaignId) throw new Error('Recurring campaign ID is required');
  if (!instanceId) throw new Error('Instance ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring/${recurringCampaignId}/instances/${instanceId}/retry`;
  const response = await api.executePostRequest<{ data: { object: RecurringCampaignDetail } }>(url);
  return response.data.data;
}
